import React from 'react';
import {
  Box,
  Drawer,
  DrawerContent,
  useBreakpointValue,
  DrawerOverlay,
  DrawerCloseButton
} from '@chakra-ui/react';
import ProductFilterBody from '@components/molecules/ProductFilterBody';

const ProductFilter = ({
  filterItems = [],
  appliedFilters = [],
  filterActive = false,
  onFilterClose = () => {},
  onFiltersApplied = (filters) => {},
  onFiltersCleared = () => {}
}) => {
  const isDesktop = useBreakpointValue({ base: false, md: true });

  return isDesktop ? (
    <Box
      position="sticky"
      top={{ base: `3.5rem`, md: `5.125rem` }}
      minWidth="18.25rem">
      <ProductFilterBody
        filterItems={filterItems}
        appliedFilters={appliedFilters}
        onFiltersApplied={onFiltersApplied}
        onFiltersCleared={onFiltersCleared}
      />
    </Box>
  ) : (
    <Drawer
      zIndex="2"
      position="relative"
      isOpen={filterActive}
      placement="right"
      onClose={onFilterClose}>
      <DrawerOverlay bg="rgba(29, 0, 62, 0.8)" />
      <DrawerContent
        style={{
          transitionDuration: filterActive ? `100ms` : `300ms`,
          transitionTimingFunction: filterActive ? `ease-out` : `ease-in`
        }}>
        <Box
          bg={{ base: `white`, md: `transparent` }}
          p="2rem"
          height="100%"
          width={{ base: `100%`, sm: `auto` }}>
          <DrawerCloseButton
            mt="2rem"
            mr="2rem"
            position="absolute"
            right="0"
            top="0"
            color="gray.400"
            cursor="pointer"
          />
          <ProductFilterBody
            filterItems={filterItems}
            appliedFilters={appliedFilters}
            onFiltersApplied={onFiltersApplied}
            onFiltersCleared={onFiltersCleared}
          />
        </Box>
      </DrawerContent>
    </Drawer>
  );
};

export default ProductFilter;
